module.exports = __webpack_public_path__ + "static/media/portfolio.8a5494a1.pdf";